import SongEditForm from '../Components/SongEditForm';

const Edit = () => {
  return (
    <div className='New Edit'>
      <h2>Edit</h2>
      <SongEditForm />
    </div>
  );
};

export default Edit;
